<template>
  <v-dialog v-model="dialogOpen" persistent max-width="750">
    <v-card>
      <v-card-title>Add new user{{(parseInt(addUserForm.quantity)>1)?'s':''}}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field outlined dense hide-details type="number" label="Quantity" v-model="addUserForm.quantity" min="1" @click="checkEditPrice('add')" @change="checkEditPrice('add')"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="pb-1"><span>Tariff</span></v-col>
          <v-col cols="4" class="pb-1"><span class="dark_grey--text">{{addUserForm.tariff.name}}</span></v-col>
          <v-col cols="2" class="pb-1"></v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-1"><span>Contract length</span></v-col>
          <v-col cols="4" class="py-1"><span class="dark_grey--text">{{addUserForm.cLength}}</span></v-col>
          <v-col cols="2" class="py-1"></v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-1"><span>Promo</span></v-col>
          <v-col cols="4" class="py-1"><span class="dark_grey--text">{{addUserForm.promo.name}}</span></v-col>
          <v-col cols="2" class="py-1"></v-col>
        </v-row>
        
        <template v-if="Object.keys(addUserForm.addons).length!==0">
          <v-divider class="my-2"></v-divider>
          <template v-for="(add, addi) in addons">
            <template v-if="!add.is_type_select">
              <v-row :key="addi">
                <v-col cols="4"><span>{{add.name}}</span></v-col>
                <v-col cols="2">
                  <span class="dark_grey--text">
                    {{(addUserForm.addons[`ad_${add.id}`].included)?`Included`:`+£${add.price}`}}
                  </span>
                </v-col>
                <v-col cols="6"><v-switch class="mt-n1" hide-details v-if="add.selectable&&!addUserForm.addons[`ad_${add.id}`].included" v-model="addUserForm.addons[`ad_${add.id}`].switched" :disabled="addUserFormLoading" @change="checkEditPrice('add')"></v-switch></v-col>
              </v-row>
            </template>
          </template>
          <template v-for="(group, groupi) in groupedAddons">
            <v-row :key="groupi">
              <v-col cols="4">{{group.name}}</v-col>
              <v-col cols="2" class=" dark_grey--text">{{(addUserForm.addons[`ad_${group.selected}`]!==undefined&&addUserForm.addons[`ad_${group.selected}`].included)?'Included':(group.price!=='-')?`+£${group.price}`:'-'}}</v-col>
              <v-col cols="6">
                <v-select v-model="group.selected" :items="group.items" item-text="name" item-value="id" item-disabled="disabled" :label="(group.selected==='')?'Select an Option':''" dense hide-details outlined @change="selectGroupedAddon(groupi,'add')"></v-select>
              </v-col>
            </v-row>
          </template>
        </template>
        
        <v-divider class="my-2"></v-divider>
        <v-row>
          <v-col cols="6" class="py-1"><span><b>Total price exc. VAT</b></span></v-col>
          <v-col cols="6" class="py-1 text-right"><span class="dark_grey--text"><b>
            {{singleUserAddonTotals('novat')}}
          </b></span></v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-1"><span><b>{{addUserForm.totals.initial.text}}</b></span></v-col>
          <v-col cols="6" class="py-1 text-right"><span class="dark_grey--text"><b>
            {{singleUserAddonTotals('initial')}}
          </b></span></v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-1"><span><b>VAT</b></span></v-col>
          <v-col cols="6" class="py-1 text-right"><span class="dark_grey--text"><b>
            {{singleUserAddonTotals('vat')}}
          </b></span></v-col>
        </v-row>
        <v-row>
          <v-col cols="6" class="py-1"><span><b>Total price</b></span></v-col>
          <v-col cols="6" class="py-1 text-right"><span class="dark_grey--text"><b>
            {{singleUserAddonTotals('total')}}
          </b></span></v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click.prevent="$emit('submit-dialog')" :loading="addUserFormLoading" :disabled="addUserFormLoading">Add new user{{(parseInt(addUserForm.quantity)>1)?'s':''}}</v-btn>
        <v-btn color="primary" small outlined class="ml-3" @click="closeDialog">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: ['dialogOpen','addUserForm','addons','groupedAddons','addUserFormLoading'],
    methods: {
      closeDialog(){
        this.$emit('close-dialog');
      },
      singleUserAddonTotals(type){
        let ret = '';
        let quanMore = parseInt(this.addUserForm.quantity)>1;
        let totals = this.addUserForm.totals;
        let totalsQuan = this.addUserForm.totalsQuan;
        switch(type){
          case 'novat':
            ret = (quanMore)?`( £${totals.totalNoVat} ) £${totalsQuan.totalNoVat}`:`£${totals.totalNoVat}`;
          break;
          case 'initial':
            ret = (quanMore)?`( £${totals.initial.value} ) £${totalsQuan.initial}`:`£${totals.initial.value}`;
          break;
          case 'vat':
            ret = (quanMore)?`( £${totals.vat} ) £${totalsQuan.vat}`:`£${totals.vat}`;
          break;
          case 'total':
            ret = (quanMore)?`( £${totals.total} ) £${totalsQuan.total}`:`£${totals.total}`;
          break;
        }
        return ret;
      },
      selectGroupedAddon(groupKey,type){
        let group = this.groupedAddons[groupKey];
        let form = (type==='edit')?this.editUserForm:this.addUserForm;
        group.items.forEach(item => {
          let is_selected = group.selected===item.id;
          if(is_selected){ group.price = (item.price!==undefined)?item.price:'-'; }
          if(form.addons[`ad_${item.id}`]!==undefined){ form.addons[`ad_${item.id}`].switched = is_selected; }
        });
        this.checkEditPrice(type);
      },
      checkEditPrice(type){
        let form = (type==='edit')?this.editUserForm:this.addUserForm;
        let tariff = form.tariff.price;
        let thePromo = form.promo;
        let adds = form.addons;
        let total = 0;
        let initial = {text:'',value:0};
        if(thePromo!==undefined && thePromo.price!==0){
          total = thePromo.price;
          initial.text = 'Promo';
        }else if(tariff!==undefined){
          total = parseInt(tariff);
          initial.text = 'Tariff';
        }
        initial.value = total.toFixed(2);
        Object.keys(adds).forEach(k=>{
          let ad = adds[k];
          if(ad.switched){
            total += ad.price;
          }
        });
        form.totals.totalNoVat = total.toFixed(2);
        form.totals.initial = initial;
        form.totals.vat = (total * this.$vatAmount).toFixed(2);
        form.totals.total = (total * (this.$vatAmount + 1)).toFixed(2);
        if(type==='add'){
          let quan = parseInt(form.quantity);
          form.totalsQuan.totalNoVat = (form.totals.totalNoVat * quan).toFixed(2);
          form.totalsQuan.initial = (form.totals.initial.value * quan).toFixed(2);
          form.totalsQuan.vat = (form.totals.vat * quan).toFixed(2);
          form.totalsQuan.total = (form.totals.total * quan).toFixed(2);
        }
      },
    },
  }
</script>

<style lang="scss" scoped></style>
